import ParallaxSection from './sections/ParallaxSection';
import GridSection from './sections/GridSection';

export {
  ParallaxSection,
  GridSection,
};
